import { DatePipe } from '@angular/common';
import { AfterViewInit, Component, Injector, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { TransactionsService } from '@services/entity/transactions.service';
import { Chart, registerables } from 'chart.js';
import '@angular/localize/init';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import { UserDto } from '@dto/userDto';
import { ChargingstationGroupDto } from '@dto/chragingstationGroupDto';
import { UsersService } from '@services/entity/users.service';
import { ChargingStationsService } from '@services/entity/charging-stations.service';
import { FormService } from '@services/form/form.service';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { TransactionFilter } from '@models/transactionFilter';
import { NgbCalendar, NgbDate, NgbDatepicker, NgbDropdown, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import annotationPlugin from 'chartjs-plugin-annotation';
import { TransactionDto } from '@dto/transactionDto';
import { ComponentBase } from '../../../abstracts/component-base';
import { ChargingStationDto } from '@dto/chargingStationDto';
import { endOfYear, getISOWeek, startOfYear } from 'date-fns';
import { startOfISOWeek } from 'date-fns/fp';
import { endOfISOWeek } from 'date-fns/esm/fp';
import startOfMonth from 'date-fns/esm/fp/startOfMonth';
import endOfMonth from 'date-fns/esm/fp/endOfMonth';
import { CreateDeliveryNoteDialogContentComponent } from '@components/dialog/create-delivery-note-dialog-content/create-delivery-note-dialog-content.component';
import { plainToClass } from 'class-transformer';
import { ActivatedRoute } from '@angular/router';
import { TransactionLocalFilter } from '@models/transactionLocalFilter';
import { CreateDeliveryCSVDialogContentComponent } from '@components/dialog/create-delivery-csv-dialog-content/create-delivery-csv-dialog-content.component';

Chart.register(...registerables);

@Component({
  selector: 'app-charging-statistics',
  templateUrl: './charging-statistics.component.html',
  styleUrls: ['./charging-statistics.component.scss'],
  providers: [FormService]
})
export class ChargingStatisticsComponent extends ComponentBase implements OnInit, AfterViewInit {

  public className = 'ChargingStatisticsComponent';

  @ViewChild('operatorView') operatorView: TemplateRef<any>;
  @ViewChild('customerView') customerView: TemplateRef<any>;

  public activeTab = 'week';
  public loading: boolean = false;
  public showChart2: boolean = false;
  public setShowChart2(bool: boolean) {this.showChart2 = bool}

  public chart: Chart;
  public chart2: Chart;
  public canvas: any;
  public canvas2: any;
  public ctx: any;
  public ctx2: any;
  public xAxisLabel: string;
  public labels: string[];
  public barChartData: number[];
  public totalAmount: number;
  public kwText = $localize`:@@ChargingStatisticsKw:Lademenge in kWh`;
  public isOperatorView: boolean;
  public isUser: boolean = false

  public max: number;
  public min: number;
  public average: number;
  public maxShow: boolean = false;
  public minShow: boolean = false;
  public averageShow: boolean = false;
  public chartGradientA: string = '#f57e00';
  public chartGradientB: string = '#ffbf00';
  public chartGradientA2: string = '#276c09';
  public chartGradientB2: string = '#4eb210';

  public date: Date;

  public customerId?: number;
  public users: UserDto[];
  public chargingStations: ChargingStationDto[];
  public groups: ChargingstationGroupDto[];

  public filteredUsers: UserDto[];
  public filteredChargingStations: ChargingStationDto[];
  public filteredGroups: ChargingstationGroupDto[];
  public transactions: TransactionDto[];

  public hoveredDate: NgbDate;
  public fromDate: NgbDate;
  public toDate: NgbDate;

  @ViewChild('dp') datePicker: NgbDatepicker;

  constructor(
    private transactionsService: TransactionsService,
    private datePipe: DatePipe,
    public formService: FormService,
    private userService: UsersService,
    private chargingStationService: ChargingStationsService,
    private dialog: NgbModal,
    private activatedRoute: ActivatedRoute,
    calendar: NgbCalendar,
    injector: Injector
  ) {
    super(injector);
    this.fromDate = calendar.getToday();
    this.toDate = calendar.getNext(calendar.getToday(), 'd', 10);
    this.getChartColor()
  }

  ngOnInit(): void {
    super.ngOnInit();
    this.isOperatorView = this.activatedRoute.snapshot.data['isOperatorView'];
    this.isUser = this.authenticationService.userHasRole("User");
    this.componentSettings.footerVisible = false;
  }

  ngAfterViewInit() {
    this.getEntitiesAsync();
  }

  getChartColor() {
    var style = window.getComputedStyle(document.body)
    const chartGradientA = style.getPropertyValue('--chart-gradient-a')
    const chartGradientB = style.getPropertyValue('--chart-gradient-b')

    if (chartGradientA && chartGradientB) {
      this.chartGradientA = chartGradientA
      this.chartGradientB = chartGradientB
    }

    const chartGradientA2 = style.getPropertyValue('--chart-gradient-a2')
    const chartGradientB2 = style.getPropertyValue('--chart-gradient-b2')

    if (chartGradientA2 && chartGradientB2) {
      this.chartGradientA2 = chartGradientA2
      this.chartGradientB2 = chartGradientB2
    }
  }

  getTransactionFilter(): TransactionFilter {
    var transactionFilter: TransactionFilter = {
      from: this.ngbDateToDate(this.fromDate).toISOString(),
      to: this.ngbDateToDateEnd(this.toDate).toISOString(),
      customerId: this.customerId
    };
    return transactionFilter;
  }

  setChartDefault() {
    this.setDefaultValues();
    this.loadBarChartDataBy('Tag');
  }

  getCurrentDay() {
    return this.datePipe.transform(this.date, 'yyyy-MM-dd');
  }

  getCurrentYear() {
    return this.datePipe.transform(this.date, 'yyyy');
  }

  setDateRangeCurrentWeek() {
    var firstDay = startOfISOWeek(this.date);
    var lastDay = endOfISOWeek(this.date);

    this.fromDate = this.convertToNgbDate(firstDay);
    this.toDate = this.convertToNgbDate(lastDay);

    this.formService.form.get("range").setValue(this.formatRange(this.fromDate, this.toDate));
  }

  setDateRangeCurrentMonth() {
    var firstDay = startOfMonth(this.date);
    var lastDay = endOfMonth(this.date);

    this.fromDate = this.convertToNgbDate(firstDay);
    this.toDate = this.convertToNgbDate(lastDay);

    this.formService.form.get("range").setValue(this.formatRange(this.fromDate, this.toDate));
  }

  setDateRangeCurrentYear() {
    var firstDay = startOfYear(this.date);
    var lastDay = endOfYear(this.date);

    this.fromDate = this.convertToNgbDate(firstDay);
    this.toDate = this.convertToNgbDate(lastDay);

    this.formService.form.get("selectedYear").setValue(this.getCurrentYear())
  }

  createForm() {
    this.formService.form = new UntypedFormGroup({
      selectedUserId: new UntypedFormControl(),
      selectedStationId: new UntypedFormControl(),
      selectedGroupId: new UntypedFormControl(),
      range: new UntypedFormControl(),
      selectedDay: new UntypedFormControl(),
      selectedYear: new UntypedFormControl()
    });

    this.setChartDefault();
    this.formService.formCreated = true;
  }

  setDefaultValues() {
    this.date = new Date();
    this.formService.form.get("selectedDay").setValue(this.getCurrentDay());
    this.formService.form.get("selectedYear").setValue(this.getCurrentYear());
    this.setDateRangeCurrentWeek();
  }

  async getEntitiesAsync(): Promise<boolean> {
    if (this.isOperatorView) {
      this.customerId = this.activatedRoute.parent.snapshot.params.key;
      this.users = await this.userService.getUsersOfCustomerAsync(this.customerId);
      this.chargingStations = await this.chargingStationService.getChargingStationsOfCustomerAsync(this.customerId);
      this.groups = await this.chargingStationService.getChargingstationGroupsOfCustomerAsync(this.customerId);
    } else if (this.isUser) {
      this.createForm();
      return true
    }
    else {
      this.users = await this.userService.getUsersOfCurrentCustomerAsync();
      this.chargingStations = await this.chargingStationService.getChargingStationsOfCurrentCustomerAsync();
      this.groups = await this.chargingStationService.getChargingstationGroupsAsync();
    }

    this.chargingStations.sort((a, b) => a.name.localeCompare(b.name));
    this.groups.sort((a, b) => a.name.localeCompare(b.name));
    this.users.sort((a, b) => a.firstName.localeCompare(b.firstName));

    this.addFreeChargeUserAndQRChargeUser();
    this.resetDropdown()
    this.createForm();

    return true
  }

  resetDropdown() {
    this.filteredChargingStations = this.chargingStations
    this.filteredGroups = this.groups
    this.filteredUsers = this.users
  }

  addFreeChargeUserAndQRChargeUser() {
    const usersToAdd = [
      { id: 'ERoamingcharge', fullName: 'eRoaming-Laden' },
      { id: 'freecharge', fullName: 'Kostenloses Laden' },
      { id: 'QRCodecharge', fullName: 'QR-Code-Laden' },
      { id: 'Terminalcharge', fullName: 'Terminal-Laden' }
    ];

    this.users.push(...usersToAdd.map(user => {
      const userDto = new UserDto();
      userDto.id = user.id;
      userDto.fullName = user.fullName;
      return userDto;
    }));
  }

  onDateSelection(date: NgbDate, drop: any) {
    if (this.activeTab == 'week') {
      this.onDateSelectionWeek(date, drop);
    }
    else if (this.activeTab == 'month') {
      this.onDateSelectionMonth(date, drop);
    }
    else if (this.activeTab == 'own') {
      this.onDateSelectionOwn(date, drop);
    }
  }

  onDateSelectionWeek(date: NgbDate, drop: any) {
    var d = new Date(date.year, date.month - 1, date.day);
    var firstDay = startOfISOWeek(d)
    var lastDay = endOfISOWeek(d);

    this.fromDate = this.convertToNgbDate(firstDay);
    this.toDate = this.convertToNgbDate(lastDay);

    this.formService.form.get("range").setValue(this.formatRange(this.fromDate, this.toDate));
    this.loadBarChartDataBy('Tag');
    drop.close();
  }

  onDateSelectionMonth(date: NgbDate, drop: any) {
    var d = new Date(date.year, date.month - 1, date.day);
    var firstDay = startOfMonth(d)
    var lastDay = endOfMonth(d);

    this.fromDate = this.convertToNgbDate(firstDay);
    this.toDate = this.convertToNgbDate(lastDay);

    this.formService.form.get("range").setValue(this.formatRange(this.fromDate, this.toDate));
    this.loadBarChartDataBy('Tag');

    drop.close();
  }

  onDateSelectionOwn(date: NgbDate, drop: NgbDropdown) {
    if (!this.fromDate && !this.toDate) {
      this.fromDate = date;
    } else if (this.fromDate && !this.toDate) {
      if (date.after(this.fromDate)) {
        this.toDate = date;
      }
      else if (date.before(this.fromDate)) {
        this.toDate = this.fromDate;
        this.fromDate = date;
      }
      else if (date.equals(this.fromDate)) {
        this.toDate = date;
      }
      drop.close();
    } else {
      this.toDate = null;
      this.fromDate = date;
    }

    this.formService.form.get("range").setValue(this.formatRange(this.fromDate, this.toDate));

    if (this.fromDate && this.toDate) {
      this.loadBarChartDataBy('Tag');
    }
  }

  convertToNgbDate(date: Date): NgbDate {
    return new NgbDate(date.getFullYear(), date.getMonth() + 1, date.getDate());
  }

  changeFromToDate(event) {
    this.fromDate = null;
    this.toDate = null;

    var fromToSplit = event.target.value.split(" - ");
    var fromParts = fromToSplit[0].split(".");
    var toParts = fromToSplit[1].split(".");

    var FromDay = Number(fromParts[0]);
    var FromMonth = Number(fromParts[1]);
    var FromYear = Number(fromParts[2]);

    this.fromDate = new NgbDate(FromYear, FromMonth, FromDay);

    var ToDay = Number(toParts[0]);
    var ToMonth = Number(toParts[1]);
    var ToYear = Number(toParts[2]);

    this.toDate = new NgbDate(ToYear, ToMonth, ToDay);

    this.formService.form.get("range").setValue(this.formatRange(this.fromDate, this.toDate));

    if (this.fromDate && this.toDate) {
      this.loadBarChartDataBy('Tag');
    }
  }

  private ngbDateToDate(ngbDate: NgbDate) {
    return new Date(ngbDate.year, ngbDate.month - 1, ngbDate.day);
  }

  private ngbDateToDateEnd(ngbDate: NgbDate) { //for filter end timestamp, should be ui date +1 day
    return new Date(ngbDate.year, ngbDate.month - 1, ngbDate.day + 1);
  }

  isHovered(date: NgbDate) {
    return this.fromDate && !this.toDate && this.hoveredDate && (date.after(this.fromDate) && date.before(this.hoveredDate) || date.after(this.hoveredDate) && date.before(this.fromDate));
  }

  isInside(date: NgbDate) {
    return date.after(this.fromDate) && date.before(this.toDate);
  }

  isRange(date: NgbDate) {
    return date.equals(this.fromDate) || date.equals(this.toDate) || this.isInside(date) || this.isHovered(date);
  }

  formatRange(fromDate: NgbDate, toDate: NgbDate) {
    return (fromDate ? '' + ('00' + fromDate.day).slice(-2) + "." + ('00' + fromDate.month).slice(-2) + "." + fromDate.year : "")
      + " - " +
      (toDate ? '' + ('00' + toDate.day).slice(-2) + "." + ('00' + toDate.month).slice(-2) + "." + toDate.year : "")
  }

  footerPreviousClicked(type, drop: NgbDropdown) {
    if (!drop.isOpen()) {
      return;
    }

    switch (type) {
      case 1:
        var newFromDateDay = this.date.getDate() - 1;
        var newFromDate = new Date();
        newFromDate.setDate(newFromDateDay);
        this.fromDate = this.convertToNgbDate(newFromDate);
        this.toDate = this.fromDate;
        break;

      case 3:
        var newFromDateDay = this.date.getDate() - 3;

        var newFromDate = new Date();
        newFromDate.setDate(newFromDateDay);

        var newToDate = new Date();
        newToDate.setDate(newFromDateDay + 2);

        this.fromDate = this.convertToNgbDate(newFromDate);
        this.toDate = this.convertToNgbDate(newToDate);
        break;

      case 5:
        var newFromDateDay = this.date.getDate() - 5;

        var newFromDate = new Date();
        newFromDate.setDate(newFromDateDay);

        var newToDate = new Date();
        newToDate.setDate(newFromDateDay + 4);

        this.fromDate = this.convertToNgbDate(newFromDate);
        this.toDate = this.convertToNgbDate(newToDate);
        break;

      case 7:
        var newFromDateDay = this.date.getDate() - 7;

        var newFromDate = new Date();
        newFromDate.setDate(newFromDateDay);

        var newToDate = new Date();
        newToDate.setDate(newFromDateDay + 6);

        this.fromDate = this.convertToNgbDate(newFromDate);
        this.toDate = this.convertToNgbDate(newToDate);
        break;

      case 'week':
        var dayLastWeek = this.date.getDate() - 7;
        var dateLastWeek = new Date();
        dateLastWeek.setDate(dayLastWeek);

        var firstday = startOfISOWeek(dateLastWeek)
        var lastday = endOfISOWeek(dateLastWeek);

        this.fromDate = this.convertToNgbDate(firstday);
        this.toDate = this.convertToNgbDate(lastday);
        break;

      case 'month':
        var lastMonth = this.date.getMonth() - 1;
        var dateLastMonth = new Date();
        dateLastMonth.setMonth(lastMonth);

        var firstday = startOfMonth(dateLastMonth)
        var lastday = endOfMonth(dateLastMonth);

        this.fromDate = this.convertToNgbDate(firstday);
        this.toDate = this.convertToNgbDate(lastday);
        break;
    }

    this.datePicker.navigateTo(this.fromDate);
    this.formService.form.get("range").setValue(this.formatRange(this.fromDate, this.toDate));
    this.loadBarChartDataBy('Tag');
    drop.close();
  }

  async changeLocalFilter() {
    switch (this.activeTab) {
      case 'week':
      case 'month':
      case 'own':
        this.calculateData('Tag')
        break;
      case 'year':
        this.calculateData('Monat')
        break;
    }
  }

  changeYear() {
    const year = this.formService.form.get("selectedYear").value
    const date = new Date(year, 7, 15)

    var firstDay = startOfYear(date);
    var lastDay = endOfYear(date);

    this.fromDate = this.convertToNgbDate(firstDay);
    this.toDate = this.convertToNgbDate(lastDay);

    this.loadBarChartDataBy('Monat')
  }

  applyLocalFilter(): TransactionDto[] {
    const formValue = this.formService.form.value;
    const transactionLocalFilter: TransactionLocalFilter = {
      chargingStationId: formValue.selectedStationId,
      groupId: formValue.selectedGroupId,
      userId: formValue.selectedUserId
    };

    let result = this.transactions.filter(t => {
      // Filter by chargingStationId
      if (transactionLocalFilter.chargingStationId != null &&
        t.chargingStationId !== transactionLocalFilter.chargingStationId) {
        return false;
      }

      // Filter by groupId
      if (transactionLocalFilter.groupId != null &&
        !t.chargingStationGroups.some(group => group.id === transactionLocalFilter.groupId)) {
        return false;
      }

      // Filter by userId
      if (transactionLocalFilter.userId != null &&
        t.userId !== transactionLocalFilter.userId) {
        return false;
      }

      return true;
    });
    this.updateDropdown(transactionLocalFilter, result)
    return result;
  }

  updateDropdown(filter: TransactionLocalFilter, transactions: TransactionDto[]) {
    this.resetDropdown();

    const existingChargingStationIds = new Set(transactions.map(t => t.chargingStationId));
    var existingGroupIds = new Set(transactions.reduce((acc, t) => { return acc.concat(t.chargingStationGroups.map(g => g.id)); }, []));
    const existingUserIds = new Set(transactions.map(t => t.userId));

    if (filter.chargingStationId) {
      this.filteredGroups = this.filteredGroups.filter(g => existingGroupIds.has(g.id));
      this.filteredUsers = this.filteredUsers.filter(u => existingUserIds.has(u.id));
    }

    if (filter.groupId) {
      this.filteredChargingStations = this.filteredChargingStations.filter(c => existingChargingStationIds.has(c.id));
      this.filteredUsers = this.filteredUsers.filter(u => existingUserIds.has(u.id));
    }

    if (filter.userId) {
      this.filteredGroups = this.filteredGroups.filter(g => existingGroupIds.has(g.id));
      this.filteredChargingStations = this.filteredChargingStations.filter(c => existingChargingStationIds.has(c.id));
    }
  }


  private loadBarChartDataBy(dayOrMonth: string) { //either 'Tag' or 'Monat'
    this.loading = true;
    const filter = this.getTransactionFilter()
    this.transactionsService.GetPowerConsumptionCustom(filter).subscribe(result => {
      this.transactions = plainToClass(TransactionDto, result).map(t => {
        if (!t.userId) {
          if (t.isFreeCharge) t.userId = 'freecharge';
          else if (t.paymentIntentId) t.userId = 'QRCodecharge';
          else if (t.sessionId) t.userId = 'ERoamingcharge';
          else if (t.hecId) t.userId = "Terminalcharge";
        }
        return t;
      });
      this.calculateData(dayOrMonth)
    }, error => { this.loading = false; })
  }

  calculateData(intervalType: string) { //intervalType either 'Tag' or 'Monat', and would be showed as x-axis label
    this.loading = true;
    const powerData = [];
    const labels = [];
    const filter = this.getTransactionFilter()
    const from = new Date(filter.from);
    const to = new Date(filter.to);
    const filteredTransactions = this.applyLocalFilter()

    const numberOfIntervals = intervalType === 'Tag'
      ? Math.ceil((to.getTime() - from.getTime()) / (1000 * 60 * 60 * 24))
      : 12;

    for (let i = 0; i <= (numberOfIntervals - 1); i++) {
      const currentDate = new Date(from);
      if (intervalType === 'Tag') {
        currentDate.setDate(from.getDate() + i);
        labels.push(currentDate.getDate());
      } else if (intervalType === 'Monat') {
        currentDate.setMonth(from.getMonth() + i);
        labels.push(i + 1);
      }

      const nextInterval = new Date(currentDate);
      if (intervalType === 'Tag') {
        nextInterval.setDate(currentDate.getDate() + 1);
      } else if (intervalType === 'Monat') {
        nextInterval.setMonth(currentDate.getMonth() + 1);
      }

      const consumptionOfInterval = filteredTransactions
        .filter(t => new Date(t.startTimestamp) >= currentDate && new Date(t.startTimestamp) < nextInterval)
        .reduce((sum, t) => sum + t.meterAmount, 0);

      powerData.push(consumptionOfInterval / 1000.0);
    }

    this.setupChart(labels, powerData, intervalType);
  }

  setupChart(labels: string[], powerData: number[], intervalType: string) {
    this.barChartData = powerData;
    this.labels = labels;
    this.xAxisLabel = intervalType;
    this.totalAmount = this.barChartData.reduce((accumulator, current) => { return accumulator + current; }, 0)

    const nonZeroPowerData = powerData.filter(z => z > 0);
    this.max = Math.max(...powerData) / 1000.0;
    this.min = nonZeroPowerData.length ? Math.min(...nonZeroPowerData) / 1000.0 : 0;
    this.average = powerData.length ? (powerData.reduce((sum, z) => sum + z, 0) / powerData.length) / 1000.0 : 0;
    this.createChart(this.kwText);
  }

  public changeChart(type) {
    switch (type) {
      case 'week':
        this.setDateRangeCurrentWeek();
        this.loadBarChartDataBy('Tag');
        break;
      case 'month':
        this.setDateRangeCurrentMonth();
        this.loadBarChartDataBy('Tag');
        break;
      case 'year':
        this.setDateRangeCurrentYear();
        this.loadBarChartDataBy('Monat');
        break;
      case 'own':
        this.setDateRangeCurrentWeek();
        this.loadBarChartDataBy('Tag');
        break;
    }
  }

  private createChart(label: string) {
    if (this.chart) this.chart.destroy();
    if (this.chart2) this.chart2.destroy();

    this.canvas = document.getElementById('powerChart');
    this.ctx = this.canvas.getContext('2d');

    var background = this.ctx.createLinearGradient(0, 0, 0, 600);
    background.addColorStop(0, this.chartGradientA);
    background.addColorStop(1, this.chartGradientB);

    Chart.register(annotationPlugin);

    this.chart = new Chart(this.ctx, {
      plugins: [ChartDataLabels],
      type: 'bar',
      data: {
        labels: this.labels,
        datasets: [
          {
            label: label,
            data: this.barChartData,
            backgroundColor: background,
            borderWidth: 0,
            xAxisID: 'x',
            yAxisID: 'y'
          },
          {
            label: 'Gesamtlademenge ' + this.totalAmount.toLocaleString() + ' kWh',
            data: null,
            backgroundColor: 'white',
            xAxisID: 'none',
          },
        ]
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          'y': {
            beginAtZero: true,
            title: { display: true, text: 'Lademenge in kWh' },
          },
          'x': {
            title: { display: true, text: this.xAxisLabel },
          },
          'none': {
            display: false
          }
        },
        plugins: {
          datalabels: {
            anchor: 'center',
            align: 'center',
            labels: {
              value: {
                color: 'white'
              }
            },
            display: function (context) {
              return null // context.dataset.data[context.dataIndex] !== 0;
            }
          },
          legend: {
            title: {
              display: true,
            },
            onClick: null
          },
          annotation: {
            annotations: {
              line1: {
                type: 'line',
                scaleID: 'y-axis-1',
                yMin: this.max,
                yMax: this.max,
                borderColor: 'tomato',
                borderWidth: 1,
                display: this.maxShow
              },
              line2: {
                type: 'line',
                scaleID: 'y-axis-2',
                yMin: this.min,
                yMax: this.min,
                borderColor: 'blue',
                borderWidth: 1,
                display: this.minShow
              },
              line3: {
                type: 'line',
                scaleID: 'y-axis-3',
                yMin: this.average,
                yMax: this.average,
                borderColor: 'green',
                borderWidth: 1,
                display: this.averageShow
              }
            }
          }
        }
      }
    });

    this.canvas2 = document.getElementById('emissionChart');
    this.ctx2 = this.canvas2.getContext('2d');

    var background = this.ctx2.createLinearGradient(0, 0, 0, 600);
    background.addColorStop(0, this.chartGradientA2);
    background.addColorStop(1, this.chartGradientB2);

    const totalSavingCo2 = (((this.totalAmount * 3.6 * 94.1) / 1000) - ((this.totalAmount * 3.6 * 119 * 0.4) / 1000)).toLocaleString();

    this.chart2 = new Chart(this.ctx2, {
      plugins: [ChartDataLabels],
      type: 'bar',
      data: {
        labels: this.labels,
        datasets: [
          {
            label: 'CO₂-Einsparung in kg',
            data: this.barChartData.map(v => ((v * 3.6 * 94.1) / 1000) - ((v * 3.6 * 119 * 0.4) / 1000)),
            backgroundColor: background,
            borderWidth: 0,
            xAxisID: 'x',
            yAxisID: 'y',
          },
          {
            label: 'CO₂-Gesamteinsparung ' + totalSavingCo2 + ' kg',
            data: null,
            backgroundColor: 'white',
            xAxisID: 'none',
          }
        ]
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          'y': {
            beginAtZero: true,
            title: { display: true, text: 'CO₂-Einsparung in kg' },
          },
          'x': {
            title: { display: true, text: this.xAxisLabel },
          },
          'none': {
            display: false
          }
        },
        plugins: {
          datalabels: {
            anchor: 'center',
            align: 'center',
            labels: {
              value: {
                color: 'white'
              }
            },
            display: function (context) {
              return null // context.dataset.data[context.dataIndex] !== 0;
            }
          },
          legend: {
            title: {
              display: true,
            },
            onClick: null
          },
          annotation: {
            annotations: {
              line1: {
                type: 'line',
                scaleID: 'y-axis-1',
                yMin: this.max,
                yMax: this.max,
                borderColor: 'tomato',
                borderWidth: 1,
                display: this.maxShow
              },
              line2: {
                type: 'line',
                scaleID: 'y-axis-2',
                yMin: this.min,
                yMax: this.min,
                borderColor: 'blue',
                borderWidth: 1,
                display: this.minShow
              },
              line3: {
                type: 'line',
                scaleID: 'y-axis-3',
                yMin: this.average,
                yMax: this.average,
                borderColor: 'green',
                borderWidth: 1,
                display: this.averageShow
              }
            }
          }
        }
      }
    });

    this.loading = false;
  }

  openCreateDeliveryNoteDialog() {
    const dialogRef = this.dialog.open(CreateDeliveryNoteDialogContentComponent, { centered: true, size: 'xl', backdrop: 'static' });


    dialogRef.componentInstance.transactions = this.applyLocalFilter().map(t => {
      if (t.isFreeCharge || t.paymentIntentId || t.sessionId || t.hecId) t.userId = null;
      return t;
    });
    dialogRef.componentInstance.userId = this.formService.form.get('selectedUserId').value;

    dialogRef.result.then((result) => {

    }, (backdrop) => {

    });
  }

  openCreateDeliveryCSVDialog() {
    const dialogRef = this.dialog.open(CreateDeliveryCSVDialogContentComponent, { centered: true, size: 'xl', backdrop: 'static' });


    dialogRef.componentInstance.transactions = this.applyLocalFilter().map(t => {
      if (t.isFreeCharge || t.paymentIntentId || t.sessionId) t.userId = null;
      return t;
    });
    dialogRef.componentInstance.userId = this.formService.form.get('selectedUserId').value;

    dialogRef.result.then((result) => {

    }, (backdrop) => {

    });
  }

}
